import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChange, SimpleChanges, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ColumnChooserSettingsModel, CommandModel, EditSettingsModel, ExcelExport, ExcelExportProperties, ExcelExportService, FilterService, GridComponent, PageService, PageSettingsModel, RowDataBoundEventArgs, SelectionSettingsModel, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { BaseGridResponse, customFilterListModel, CustomGridButton, CustomGridColor, CustomGridFiltering, CustomGridImg, CustomgridOptions, CustomGridSorting, GridCheckBoxChangeData, GridColConfig, GridRowCheckboxChangeData, GridStatusIdb, RowCountResponse } from './custom-grid';
import * as _ from 'lodash';
import { CustomGridSService } from './custom-grid-s.service';
import { filter } from 'lodash';
import { Observable, Subject, Subscription, debounceTime, takeUntil } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { AbsLanguage } from 'src/app/features/abstract/absLanguage';
import { Store } from '@ngrx/store';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { LanguagesMapper } from 'src/app/model/languages/languages-mapper';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { AppState } from 'src/app/store/root.state';
import { EmitType } from '@syncfusion/ej2-base';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { environment } from 'src/environments/environment';
import { IdbDataResponse } from 'src/app/model/idb';
import { IdbService } from 'src/app/services/idb.service';
import { Session } from 'src/app/model/session';
import { triggerFocus } from '@syncfusion/ej2-angular-inputs';
import { CustomDatePickerComponent } from '../custom-date-picker/custom-date-picker.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CustomDropDownListComponent } from '../custom-drop-down-list/custom-drop-down-list.component';
import { DropDownBase, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';


@Component({
  selector: 'app-custom-grid',
  templateUrl: './custom-grid.component.html',
  styleUrls: ['./custom-grid.component.scss'],
  providers: [
    SortService,
    PageService,
    ToolbarService,
    FilterService,
    ExcelExportService,
  ],
  animations: [
    trigger('onOff', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1, }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('100ms', style({ opacity: 0 }))
      ])
    ])
  ],
})
export class CustomGridComponent extends AbsLanguage implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('Ctablel') tableEl: GridComponent | undefined;
  @ViewChild('mobileFiltering') dialogComp!: CustomDialogComponent; //mobile filters

  @ViewChildren(CustomDropDownListComponent) customComponentChildren?: QueryList<CustomDropDownListComponent>;

  @Input() dataSource: Array<any> = new Array<any>;
  @Input() gridColConfig!: Array<GridColConfig>;
  @Input() pageSettings: PageSettingsModel | undefined;
  @Input() paging: boolean | undefined;
  @Input() template: TemplateRef<any> | undefined;
  @Input() tableOptions: CustomgridOptions | undefined;
  @Input() widthT: string | undefined;
  @Input() heightT: string | undefined;


  // outputs
  @Output() onActionBegin: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRowDataBound: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSwitchChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropdownChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataSourceChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onActionComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRowSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onGridCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();


  languages!: LanguagesMapper;

  parsedData: BaseGridResponse | undefined;
  parsedOption: CustomgridOptions | undefined;
  parsedPageOptions: PageSettingsModel | undefined;
  totalRows: number = 0;
  parsedSwitchData: any;
  lastSession: boolean = false;
  showFilter: boolean = false;

  chooserOpen: boolean = false;

  // subscription for http call
  private theEnd$ = new Subject<void>();

  targetElement!: HTMLElement;

  filterSubject$: Subject<any> = new Subject<any>();
  filterButtonClass: string = 'icon-search'
  filterTooltip: string = ''

  ready: boolean = false;
  loading: boolean = false;

  pageSettingsDefault: PageSettingsModel = {
    pageSize: 50,
    pageSizes: [50, 100, 200],
    pageCount: 10,
    currentPage: 1,
    //totalRecordsCount: 50,
  }


  getScreenWidth: number = 0;
  getScreenHeight: number = 0;
  rowMode: string = '';

  barcodeWidth: number = 1;

  // ordinamento tabella
  sortTaable: CustomGridSorting[] = [];

  // filtri tabella
  filterTable: customFilterListModel[] = [];

  gridSelectionSetting: SelectionSettingsModel = {
    checkboxOnly: true,
  };

  session?: Session;

  editCommands: CommandModel[] = [
    {
      type: 'Edit',
      buttonOption: {
        cssClass: 'edit-button p-4 rounded-2xl'
      }
    },
    {
      type: 'Save',
      buttonOption: {
        cssClass: 'edit-button p-4 rounded-2xl'
      }
    },
    {
      type: 'Cancel',
      buttonOption: {
        cssClass: 'edit-button p-4 rounded-2xl'
      }
    },
  ];


  constructor(
    private customGridService: CustomGridSService,
    protected override store: Store<AppState>,
    protected override translateService: TranslateService,
    private translatePipe: TranslatePipe,
    private languageService: LanguagesService,
    private idb: IdbService,
    private localStorageService: LocalStorageService
  ) {

    //translate service
    super(store, translateService);
    this.languages = languageService.getTexts();

    this.session = this.localStorageService.getSession() || undefined;

    this.filterTooltip = this.translatePipe.transform(this.languages.Grid.ShowFilters)


    if (this.widthT == undefined) {
      this.widthT = 'auto';
    }

    if (this.heightT == undefined) {
      this.heightT = 'auto';
    }

    // if(this.pageSettings == undefined) {
    //   //this.pageSettings = this.pageSettingsDefault;
    //   this.parsePage(this.pageSettingsDefault);
    // }

    if (this.paging == undefined) {
      this.paging = true;
    }

    if (this.dataSource == null) {
      this.dataSource = [];
    }

  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    //this.barcodeWidth =
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenHeight > this.getScreenWidth) {
      this.rowMode = "Vertical"
    } else {
      this.rowMode = "Orizzontal"
    }
  }


  initTargetEl: EmitType<object> = () => {
    this.targetElement = document.body;
  }

  ngOnDestroy(): void {
    //this.dataSource = [];
    //this.theEnd$.unsubscribe();
    // unsubscribe observable and subscriptions
    this.theEnd$.unsubscribe();
  }

  showFilters(event: any) {
    this.showFilter = !this.showFilter;
    if (this.filterButtonClass == 'icon-close') {
      this.filterTable.forEach((x, index) => {
        this.filterTable[index].filterValue = '';
      })
      this.filterButtonClass = 'icon-search'
      this.filterTooltip = this.translatePipe.transform(this.languages.Grid.ShowFilters);
      this.tableEl?.goToPage(1);
      let o = 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);


      /* if (this.rowMode == "Vertical") {
        this.dialogComp.close()
      }*/
    } else { 
      this.filterButtonClass = 'icon-close'
      this.filterTooltip = this.translatePipe.transform(this.languages.Grid.ClearFilters);
      /* if (this.rowMode == "Vertical") {
        this.dialogComp.open()
      } */
    }
  }

  onDialogOpen(event: any) {
    event.preventFocus = true;
  }

  ngOnInit(): void {
    this.onWindowResize();

    this.initTargetEl();


    setTimeout(() => {
      this.ready = true;
    }, 500)


    if (this.pageSettings) {
      this.pageSettings.pageCount = 10;
      //this.pageSettings.pageCount = 2;
    }
    //subject for filtering
    this.filterSubject$.pipe(debounceTime(500)).subscribe({
      next: (value: any) => {
        console.error("\n \n this is the value recived \n \n");
        console.log(value);
        console.log("loop all the filters value");
        this.filterTable.forEach((x, index) => {
          //console.log("this is index");
          //console.log(index)
          //console.log("this is this.filterTable[index]");
          //console.log(this.filterTable[index])

          //console.log("this is value.target");
          //console.log(value.target)
          console.log("looping, with index: "+ index);
          console.log(x);
          console.log("🚀 ~CURRENT FILTER:", this.filterTable[index])

          if(x.filterDropdown == true){
            if(x.field == value.field){
              x.filterValue = value.id;
            }
          }

        })
        console.log("Dati da inviare");
        console.log(this.filterTable);




        this.tableEl?.goToPage(1);
        let o = 1;
        let ps = this.pageSettings!.pageSize || 25;
        let ofs = (o - 1) * (ps);


        if (this.tableOptions!.notLazy != true) {
          this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
        }

      }
    });
  }

  pushFilter(value: any) {
    console.warn("Start filter push");
    console.log(value)
    this.filterSubject$.next(value);
  }


  ngAfterViewInit(): void {

    if (this.tableOptions?.gridName) {

      this.idb.getItemRow(environment.idbTables.GridStatus, `${this.tableOptions.gridName}-${this.session?.id}`).then((data: IdbDataResponse) => {


        this.filterTable = _.cloneDeep(data.item.filters);
        console.log("🚀 ~ file: custom-grid.component.ts:226 ~ CustomGridComponenasfdsgsgsfdsft ~ this.idb.getItemRow ~ this.filterTable:", this.filterTable)


        let showFilter: boolean = false;
        this.tableEl!.pageSettings.pageCount = 10;
        this.pageSettings!.pageCount = 10;
        this.tableEl!.pageSettings.currentPage = data.item.currentPage;
        this.pageSettings!.currentPage = data.item.currentPage;


        setTimeout(() => {
          for (let element of this.filterTable) {
            if (element.filterValue != '' && element.filterValue != undefined) {
              showFilter = true;
              //break;
            }
            /* if(element.type == 'dropdown') {
              if(this.customComponentChildren != undefined)  {
                this.customComponentChildren.forEach((data, index) => {

                  if (data.fieldName == this.filterTable[index].field) {
                    let xx: CustomDropDownListComponent | undefined = data.dropDownListObj;
                    //console.warn("\n \n THIS SHIT IS THE VALUE \n \n"+xx?.value);
                    if(data.dropDownListObj != undefined) {
                      //this.filterTable[index].filterValue = xx.value.toString();    
                      setTimeout(() => {
                        data.dropDownListObj!.value = element.filterValue || 0;
                        data.value = element.filterValue;
                      }, 10);                                        
                    }                
                  }

                });
              }              
            } */
          }

          if (showFilter == true) {

            this.showFilters(true);
            // RENDILO GLOBALE E IN BASE ALL'uTENTE AGGIUNGI UN VALORE ALL'oGGETTO DELLA GRID CHIAMATO NOME PER PRENDERE I DATI DELLA TABELLA  E AGIGUNGI L?UTENTE 
          }

          if (showFilter == true || data.item.currentPage != 1) {

            if (this.tableOptions!.notLazy != true) {
              let o = this.pageSettings!.currentPage || 1;
              let ps = this.pageSettings!.pageSize || 25;
              let ofs = (o - 1) * (ps);
              this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);

              this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
              this.parsePage(this.pageSettings || this.pageSettingsDefault);
              if (this.pageSettings != undefined || this.pageSettings != null) {
                this.pageSettingsDefault = this.pageSettings;
              }
            }

          } else {
            this.tableEl!.pageSettings.currentPage = 1;
            this.pageSettings!.currentPage = 1;
            if (this.tableOptions!.notLazy != true) {
              let o = 1;
              let ps = this.pageSettings!.pageSize || 25;
              let ofs = (o - 1) * (ps);
              this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
            }
          }


          //  this.firstLoad = false;
        }, 100);
      }).catch(() => {
        //this.firstLoad = false;
        console.log("NO FILTERS IN IDB")

        this.gridColConfig.forEach(c => {
          if (c.filter != false) {
            this.filterTable.push(
              {
                field: c.field,
                filterValue: c.filterValue || '',
                type: c.type,
                name: c.name,
                dropdownFilterUrl: c.dropdownFilterUrl,
                filterDropdown: c.filterDropdown
              }
            );
            //console.log("🚀 ~ file: custom-grid.component.ts:444 ~ CustomGridComponent ~ this.idb.getItemRow ~ cccccccccc:", c)

          }
        });

        if (this.tableOptions!.notLazy != true) {
          let o = this.pageSettings!.currentPage || 1;
          let ps = this.pageSettings!.pageSize || 25;
          let ofs = (o - 1) * (ps);
          this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);

          this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
          this.parsePage(this.pageSettings || this.pageSettingsDefault);
          if (this.pageSettings != undefined || this.pageSettings != null) {
            this.pageSettingsDefault = this.pageSettings;
          }
        }

      })
    } else {
      console.log("NO FILTERS IN IDB")

      this.gridColConfig.forEach(c => {
        if (c.filter != false) {
          this.filterTable.push(
            {
              field: c.field,
              filterValue: c.filterValue || '',
              type: c.type,
              name: c.name,
              dropdownFilterUrl: c.dropdownFilterUrl,
              filterDropdown: c.filterDropdown
            }
          );
          //console.log("🚀 ~ file: custom-grid.component.ts:444 ~ CustomGridComponent ~ this.idb.getItemRow ~ cccccccccc:", c)

        }
      });

      if (this.tableOptions!.notLazy != true) {
        let o = this.pageSettings!.currentPage || 1;
        let ps = this.pageSettings!.pageSize || 25;
        let ofs = (o - 1) * (ps);
        this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);

        this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
        this.parsePage(this.pageSettings || this.pageSettingsDefault);
        if (this.pageSettings != undefined || this.pageSettings != null) {
          this.pageSettingsDefault = this.pageSettings;
        }
      }
    }



    //set filterTable fields

    /*this.customGridService.getLazyData(this.tableOptions!.apiCallurl,ofs,ps).subscribe({
      next: (data: Array<any>) => {
        if(this.tableEl != undefined){
          this.tableEl!.dataSource = data;
        }
        this.dataSource = data;
      },
      error: () => {

      },
      complete: () => {

      }
    });*/

    //this.tableEl!.refresh();
    //setTimeout(() => {

    //}, 0);

    console.warn("\n Tabella aggiornata! \n");
    console.log(this.tableEl?.pageSettings);
  }

  resetTable() {
    //this.filterTable = [];
    /*this.gridColConfig.forEach(c => {      
      if(c.filter != false){  
        this.filterTable.push(
          {
            field: c.field,
            value: '',
          }
        );
      }
        console.log(this.filterTable);
    });*/

    if (this.tableOptions!.notLazy != true) {
      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);

      this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
      this.parsePage(this.pageSettings || this.pageSettingsDefault);
      if (this.pageSettings != undefined || this.pageSettings != null) {
        this.pageSettingsDefault = this.pageSettings;
      }

    }




  }

  csvExport() {
    console.log(this.parsedData)
    if (this.tableOptions?.getAllUrl != undefined) {
      this.customGridService.getAllData(this.tableOptions.getAllUrl || '').pipe(takeUntil(this.theEnd$)).subscribe({
        next: (response: any) => {
          this.tableEl?.csvExport({
            separator: `;`,
            dataSource: response,
            fileName: `${this.tableOptions?.apiTableName}.csv`,
          });
        }
      })
    } else {
      this.tableEl?.csvExport({
        separator: `;`,
        dataSource: this.parsedData?.result,
        fileName: `${this.tableOptions?.apiTableName}.csv`
      });
    }
  }

  ngOnChanges(changes: { options: SimpleChange, dataSource: SimpleChange, pageSettings: SimpleChange, tableOptions: SimpleChange, filterTable: SimpleChange, gridColConfig: SimpleChange }): void {
    if (changes.gridColConfig) {
      //this.resetTable();
    }
    // console.warn(" \n \n \n changes detected");
    // console.log(changes);
    // if(changes.options){
    //   let o = this.pageSettings!.currentPage || 1;
    //   let ps = this.pageSettings!.pageSize || 25;
    //   let ofs = (o-1) * (ps);
    //   this.getDataLazy(ofs,ps,1);
    //   this.refreshTable()
    // }
    // /*if(changes.dataSource) {
    //   console.log("\n \n \n Data source changed ?");
    //   if(this.tableEl != undefined) {
    //     this.tableEl.dataSource = changes.dataSource.currentValue;
    //     this.tableEl.refresh();
    //     console.log("\n yes it changed");
    //   }
    //   this.tableEl!.dataSource = changes.dataSource.currentValue;
    //   this.onDataSourceChange.emit(changes.dataSource.currentValue);
    // }*/


    // if(changes.pageSettings) {
    //   if(this.tableEl != undefined) {
    //     //this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
    //     this.parsePage(changes.pageSettings.currentValue);
    //   }
    // }




    // if(changes.tableOptions){
    //   this.parseOptions(changes.tableOptions.currentValue);
    //   let o = this.pageSettings!.currentPage || 1;
    //   let ps = this.pageSettings!.pageSize || 25;
    //   let ofs = (o-1) * (ps);
    //   this.getDataLazy(ofs,ps,1);

    //   if(this.tableEl != null || this.tableEl != undefined) {
    //     this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
    //   }


    //   this.parsePage(this.pageSettings || this.pageSettingsDefault);
    //   if(this.pageSettings != undefined || this.pageSettings != null) {
    //     this.pageSettingsDefault = this.pageSettings;
    //   }
    // }

    // this.tableEl?.refresh()
  }

  getImagePath(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridImg).path;
  }

  // button
  getButtuonIcon(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.icon || undefined;
  }

  getButtonLabel(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.label || undefined;
  }

  getButtonAlign(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.align || undefined;
  }

  // color
  getColorHeight(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).height;
  }

  getColorWidth(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).width;
  }

  parseOptions(options: CustomgridOptions) {
    this.parsedOption = _.cloneDeep(options);
    if (this.tableEl != undefined) {
      this.tableEl.refresh();
    }
  }

  parseData(data: BaseGridResponse) {
    this.parsedData = _.cloneDeep(data)
    console.log(this.parsedData)
    if (this.tableEl != undefined) {
      this.tableEl.dataSource = data;
    }

    // setTimeout(()=>{
    //   if(data==null){
    //     this.parsedData=[];
    //   }
    // },10)


  }

  checkFilters(e: any) {

    this.showFilter = !this.showFilter;
    console.warn("\n \n this are the filters \n \n");
    console.warn(this.filterTable);
    this.filterTable.forEach((x, index) => {

      if (x.field == e.target.id) {
        this.filterTable[index].filterValue = e.target.value
      }
    })
    console.log("Dati da inviare");
    console.log();


    // imposto variabile per sorting

    // se ci sono ordinamenti aggiungo campi
    if (e.columnName != undefined) {
      this.sortTaable = [];
      this.sortTaable.push(
        {
          field: e.columnName,
          direction: e.direction,
        },
      );
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    if (this.tableOptions!.notLazy != true) {
      this.tableEl?.goToPage(1);
      let o = 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o - 1) * (ps);



      this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
    }

  }

  onKeyPress(e: any) {
    console.log(e)
  }


  //SPOSTA IL SORTING DENTRO IL NUOVO EVENTO

  /*******************************************************************************************  azioni lazy loading **************************************************/
  emitActionBegin(e: any) {
    console.log(e);
    this.onActionBegin.emit(e);
    if (this.lastSession) {
      return;
    }

    // preparo i filtri
    console.log(e.columns);
    // filtri vuota


    // se ci sono filtri aggiungo campi
    if (e.columns != undefined) {

      /*e.columns.forEach((c: any) => {
        this.filterTable.push(
          {
            field: c.field,
            filterValue: c.filterValue || '',
            type: c.type,
            name: c.name,
            dropdownFilterUrl: c.dropdownFilterUrl,
            filterDropdown: c.filterDropdown
          }
        );
      });
      console.log("Dati da inviare");
      console.log(this.filterTable);*/
    } else {

    }

    // imposto variabile per sorting

    // se ci sono ordinamenti aggiungo campi
    if (e.columnName != undefined) {
      this.sortTaable = [];
      this.sortTaable.push(
        {
          field: e.columnName,
          direction: e.direction,
        },
      );
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    // page data
    let o = this.pageSettings!.currentPage || 1;
    let ps = this.pageSettings!.pageSize || 25;
    let ofs = (o - 1) * (ps);


    if (e.requestType == 'paging') {
      let currentPage = e.currentPage - 1;
      let offset = e.pageSize * currentPage;

      /*console.log("\n ============================== \n sorting");
      //let filters = this.tableEl!.sortSettings.columns || [];
      if(filters.length > 0) {
        filters.forEach(f => {
          sort.push({direction: f.direction || "", field: f.field || ""});
        });
      }*/

      if (this.tableOptions!.notLazy != true) {
        this.getDataLazy(offset, e.pageSize, e.currentPage, this.filterTable, this.sortTaable);
      }

      //this.getDataLazy(ofs,ps,this.pageSettings?.currentPage,filters,sort);
    }
    // if(e.requestType == 'filtering') {
    //   console.log("Doing filter");
    //   this.getDataLazy(ofs,ps,this.pageSettings?.currentPage,this.filterTable,this.sortTaable);
    // }
    if (e.requestType == 'refresh') {
      //better do nothing
    }
    if (e.requestType == 'sorting') {
      /*console.log("\n Filter active in table ");
      console.log(e);

      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o-1) * (ps);*/

      if (this.tableOptions!.notLazy != true) {
        this.tableEl?.goToPage(1);
        this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);
        this.tableEl?.goToPage(this.pageSettings?.currentPage || 1);
      }

    }

    return;
  }

  /**
   * Actions executed on row selection
   * @param e any
   */
  rowSelected(e: any) {
    this.onRowSelect.emit(e);
  }


  switchChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onSwitchChange.emit(d);
  }


  dropdownChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onDropdownChange.emit(d);
  }

  checkBoxChange(event: any, data: any) {
    let d: Object = {
      event: event,
      data: data,
    };
    this.onCheckBoxChange.emit(d);
  }

  emitActionComplete(event: any) {
    console.warn(event)
    this.onActionComplete.emit(event);
  }

  rowDB(event: any) {
    this.onRowDataBound.emit(event);
  }

  emitBtnClick(data: any, event: any, name: any) {
    let d: Object = {
      action: event,
      name: name,
      data: data,
    }
    this.onButtonClick.emit(d);
  }

  parsePage(page: PageSettingsModel) {
    this.parsedPageOptions = _.cloneDeep(page);
    if (this.tableEl != undefined) {
      this.tableEl.pageSettings = page;
    }
  }

  dataStateChange(event: any) {
    console.error('DATASTATE HAS CHANGED')
    console.error(event)

    if (event.sorted != undefined) {
      this.sortTaable = [];
      let arr: Array<any> = event.sorted;
      for (let x of arr) {
        this.sortTaable.push(
          {
            field: x.name,
            direction: x.direction,
          },
        );
      }
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    if (this.tableOptions!.notLazy != true) {
      this.getDataLazy(event.skip, event.take, event.action.currentPage, this.filterTable, this.sortTaable);
    }
  }

  getDataLazy(offset: number, max: number, currentPage?: number, filter?: customFilterListModel[], sort?: CustomGridSorting[]) {
    this.tableEl?.showMaskRow();
    this.loading = true;

    document.getElementById('scrollTop')?.scrollIntoView({ behavior: 'smooth' });

    // if(this.tableEl != undefined) {
    //   this.tableEl!.dataSource = [];
    // }

    if (this.tableOptions!.notLazy != true) {
      this.customGridService.getLazyData(this.tableOptions!.apiCallurl, offset, max, filter, sort).pipe(takeUntil(this.theEnd$)).subscribe({
        next: (data: any) => {
          this.dataSource = data;
          this.parsedData = _.cloneDeep(data)

          // this.onDataSourceChange.emit(data);
          // this.totalRows = data.rows
          // if(this.lastSession) {
          //   this.parseData(data);
          // }
          this.tableEl!.dataSource = this.dataSource;

          this.onActionBegin.emit(this.dataSource);

          let idbData: GridStatusIdb = {
            currentPage: this.tableEl!.pageSettings.currentPage || 1,
            filters: _.cloneDeep(this.filterTable)
          }

          if (this.tableOptions?.gridName) {

            this.idb.addItemRow(environment.idbTables.GridStatus, idbData, `${this.tableOptions.gridName}-${this.session?.id}`);
            console.log("🚀 ~ file: custom-grid.component.ts:889 ~ CustomGridComponent ~ this.customGridService.getLazyData ~ this.session:", this.session)
          }

          this.tableEl?.hideSpinner();
          this.loading = false;



        },
        error: (e: any) => {
          console.error("Could not get any data!!");
        },
        complete: () => {
          this.onActionComplete.emit("");
          //setTimeout(() => {

          //}, 100);

          /* // let c = currentPage || 1;
           // setTimeout(() => {
           //   this.countRows(c, max, filter);
           // }, 100);
           setTimeout(() => {
           this.pageSettingsDefault!.currentPage = currentPage;
           this.pageSettingsDefault!.pageSize = max;
           this.pageSettingsDefault.totalRecordsCount = this.totalRows;
           let pages = this.totalRows / max;
           //this.pageSettingsDefault!.pageCount = Math.ceil(pages);
   
   
           this.pageSettings = this.pageSettingsDefault;
   
           if(this.tableEl != null || this.tableEl != undefined) {
             if(this.pageSettings.totalRecordsCount != undefined && this.pageSettings.totalRecordsCount > 0) {
               this.tableEl!.pageSettings = this.pageSettingsDefault;
             }
   
           }
           }, 50);*/
        }
      });
    }
  }
  /*
    countRows(currentPage: number, pageS: number, filters?: Array<CustomGridFiltering>) {
        this.customGridService.countRows(this.tableOptions!.rowsCallurl, this.tableOptions!.apiTableName, filters).pipe(takeUntil(this.theEnd$)).subscribe({
          next: (rows: any) => {
            //console.log(rows);
            this.pageSettingsDefault!.totalRecordsCount = rows;
            let pages = rows / pageS;
            
            if(rows % pages >0){
              pages++;
            }
            setTimeout(() => {
              console.warn(this.tableEl?.pageSettings.pageCount);
            }, 100);
            //this.pageSettingsDefault!.pageCount = Math.ceil(pages);
            
            this.totalRows = rows;
            this.pageSettingsDefault!.currentPage = currentPage;
            this.pageSettingsDefault!.pageSize = pageS;
  
            this.pageSettings = this.pageSettingsDefault;
  
            console.warn(this.pageSettingsDefault);
            //console.warn(this.tableEl!.pageSettings);
            if(this.tableEl != null || this.tableEl != undefined) {
              if(this.pageSettings.totalRecordsCount != undefined && this.pageSettings.totalRecordsCount > 0) {
                this.tableEl!.pageSettings = this.pageSettingsDefault;
              }
  
            }
  
            this.lastSession = false;
          },
          error: (e:any) => {
            console.error("Impossibile ottenere i dati");
          },
          complete: () => {
  
          }
        });
  
    }
  */


  //display column chooser
  showChooser() {
    let div = document.getElementById('chooserButton');

    this.tableEl?.columnChooserModule.openColumnChooser(300, 30);
    /*   div?.focus();
      div?.blur(); */
  }



  /**
   * Push data in to the grid
   */
  refreshTable() {
    /*this.tableEl!.addRecord(e);
    this.tableEl!.refresh();*/

    if (this.tableOptions!.notLazy != true) {
      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);
    }
  }


  setData(data: Array<any>) {
    this.tableEl!.dataSource = data;
  }

  /*setExcelExportOnGrid() {
    this.tableEl?.allowExcelExport = true;
  }*/

  /**
   * Trigger on every cell selct // after the cell is selectd
   * @param event any 
   */
  //GridCheckBoxChangeData
  gridCheckboxChange(event: GridCheckBoxChangeData) {
    let checkedDataArray: any[] = [];
    if (this.parsedOption?.notLazy == undefined || this.parsedOption.notLazy == false) {
      if (this.parsedData != undefined && this.parsedData.result != undefined) {
        event.selectedRowIndexes.forEach(val => {
          checkedDataArray.push(this.parsedData?.result[val]);
        });
      }
    }
    let dataPush: GridRowCheckboxChangeData = {
      data: checkedDataArray,
      event: event,
    };
    this.onGridCheckBoxChange.emit(dataPush);
  }

  ///return date as value

  returnDate(input: string): Date {
    return new Date(input);
  }


  // edit row
  startRowEdit(event: any) {
    console.warn("About to start row edit");
    this.tableEl?.startEdit();
  }


  getSVG(svg: any) {
    return btoa(svg)
  }
}
